import * as React from "react";

/**
 * Adds a listener to clicks outside the reference HTML element.
 * @param ref the HTML element.
 * @param callback the function to run when user clicks outside the HTML element.
 */
export function useClickOutsideRef(refs: (React.MutableRefObject<HTMLElement | null> | undefined)[], callback: (event: MouseEvent) => void) {
  React.useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      const validRefs = refs.filter(ref => ref && !!ref.current);

      if (validRefs.every(ref =>
        ref &&
        ref.current &&
        !ref.current.contains(event.target as Node))) {
        callback(event);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [refs]);
}